export var LinkedItemType;
(function (LinkedItemType) {
    LinkedItemType["Goal"] = "goal";
    LinkedItemType["Zoning"] = "zoning";
    LinkedItemType["Widget"] = "workspace";
})(LinkedItemType || (LinkedItemType = {}));
//# sourceMappingURL=linked-item-type.enum.js.map